/* Accessibility fixes (Lighthouse fix plan, Oct 2026).
   Loaded with defer after custom-all.js, so its jQuery ready handler runs after the theme has
   initialised sliders and cloned the offers strip. Behaviour of existing click handlers is unchanged. */
(function ($) {
  'use strict';
  if (!$) return;

  // 1. Icons built as <div>/<svg> become keyboard-operable buttons (Enter/Space fire the existing click handler).
  var ICON_BUTTONS = [
    ['.header-icons .search-open', 'Open search'],
    ['#searchIcon', 'Search'],
    ['.header-icons .site-header-cart--button', 'Open cart'],
    ['.search-input .goback', 'Close search'],
    ['#mobileMenu .close-menu', 'Close menu'],
    ['#cart_drawer .sides_cross_image', 'Close cart']
  ];

  function makeButtons() {
    ICON_BUTTONS.forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (el) {
        if (el.getAttribute('data-a11y-btn')) return;
        el.setAttribute('data-a11y-btn', '1');
        el.setAttribute('role', 'button');
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
        if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', pair[1]);
        el.querySelectorAll('svg').forEach(function (svg) {
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('focusable', 'false');
        });
        el.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
          e.preventDefault();
          el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          if (el.matches('.search-open')) {
            var input = document.getElementById('searchInput');
            if (input) setTimeout(function () { input.focus(); }, 50);
          }
        });
      });
    });
  }

  // 2. Links/buttons inside slides Slick has hidden (aria-hidden="true") leave the tab order.
  var FOCUSABLE = 'a[href], button, input, select, textarea';
  function syncSlides(slider) {
    $(slider).find('.slick-slide').each(function () {
      var hidden = this.getAttribute('aria-hidden') === 'true';
      $(this).find(FOCUSABLE).each(function () {
        if (hidden) {
          this.setAttribute('tabindex', '-1');
        } else if (this.getAttribute('tabindex') === '-1') {
          this.removeAttribute('tabindex');
        }
      });
    });
  }

  // 3. Closed cart drawer is off-screen, so it must not take keyboard focus.
  function guardDrawer() {
    var drawer = document.getElementById('cart_drawer');
    if (!drawer || !('inert' in HTMLElement.prototype)) return;
    var sync = function () {
      if (drawer.classList.contains('active')) drawer.removeAttribute('inert');
      else drawer.setAttribute('inert', '');
    };
    sync();
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  // 4. custom-all.js clones the offers list for the marquee; only the original (last) list is read out.
  function hideMarqueeClones() {
    var lists = document.querySelectorAll('.marquee-block .marquee-item-list');
    for (var i = 0; i < lists.length - 1; i++) lists[i].setAttribute('aria-hidden', 'true');
  }

  $(document).on('init reInit afterChange', '.slick-slider', function () {
    syncSlides(this);
  });

  $(function () {
    makeButtons();
    $('.slick-initialized').each(function () { syncSlides(this); });
    guardDrawer();
    hideMarqueeClones();
  });
})(window.jQuery);